import type { MarketsApi } from "@/v2/api/metadata/markets";
import { createFeedConfigDialogApi } from "@/v2/kits/feed-config";
import { marketId } from "../../shared";

export function createMarketFeedConfigApi(marketsApi: MarketsApi) {
  return createFeedConfigDialogApi(({ values }) => marketId(values), {
    getFeedTypeMappings: marketsApi.getFeedTypeMappings.bind(marketsApi),
    getFeedInstanceMappings: marketsApi.getFeedInstanceMappings.bind(marketsApi),
    updateEntity: async (entityId, payload) => {
      await marketsApi.update(entityId, payload);
    },
  });
}
